import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import IntroSubPages from '../components/Intro/IntroSubPages';
import GridGroup from '../components/Common/GridGroup';
import SplitView from '../components/Common/SplitView';
import PricingView from '../components/Common/PricingView';
import Seo from '../components/Seo';


const DropDownPages = (props) => {
    const data = props.pageData;
    return (
        <Layout pageName={data.pageHeading}>
            {/* <Helmet>
                <title>{data.pageHeading}</title>
                <meta name="description" content={data.pageDescription}/>
            </Helmet> */}
            <Seo 
            title={data.pageHeading} 
            description={data.pageDescription}
            />
            <IntroSubPages
                heading={data.pageHeading}
                description={data.pageDescription}
                buttonOneText={data.buttonOneText}
                buttonTwoText={data.buttonTwoText}
                image={data.image}
            />
            {data.gridGroupList && (<>
            {data.gridGroupList.map((grid) => {
                return (
                    <GridGroup
                        gridHeadingStrong={grid.gridHeadingStrong}
                        gridDescription={grid.gridDescription}
                        gridItems={grid.gridItems}
                    />
                );
            })}
            {data.splitView && <SplitView splitViewData={data.splitView}/>}
            {data.pricingView && <PricingView pricingView={data.pricingView}/>}
            </>)}
        </Layout>
    );
};

DropDownPages.propTypes = {
    pageData: PropTypes.any,
}

export default DropDownPages;